module.exports = new __parcel__URL__("releases-preview-dark.7aa6179c.svg").toString();